<template>
    <el-card class="box-card">
        <el-row>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                         class="unitWidth" size="small">
                    <el-form-item label="所属工厂">
                        <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable
                                   @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                       :value="factory.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable
                                   @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                       :value="shop.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                       :value="section.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable
                                   @change="lineChange">
                            <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                       :value="line.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="排序维度"  >

                  	<el-select  clearable v-model="searchParams.sortSelected" clearable>
                  		<el-option value="devCode" label="设备编号">设备编号</el-option>
                       	<el-option value="sumCount" label="次数">次数</el-option>
                       	<el-option value="responseTime" label="响应时长">响应时长</el-option>
                       	<el-option value="avgResponseTime" label="平均响应时长">平均响应时长</el-option>
                       	<el-option value="repairTime" label="系统记录维修时长">系统记录维修时长</el-option>
                       	<el-option value="probTime" label="故障总时长">故障总时长</el-option>
                       	<el-option value="twoRate" label="两小时修复率">两小时修复率</el-option>
                       	<el-option value="MTBF" label="MTBF">MTBF</el-option>
                       	<el-option value="MTTR" label="MTTR">MTTR</el-option>
                  	</el-select>
                  </el-form-item>
                  <el-form-item label="排序方式" >
                  	<el-select  clearable v-model="searchParams.sort" clearable>
                  		<el-option value="asc" label="升序">升序</el-option>
                  		<el-option value="desc" label="降序">降序</el-option>
                  	</el-select>
                  </el-form-item>
                  <el-form-item label="查看条数" >
                  	<el-input v-model="searchParams.number"  clearable></el-input>
                  </el-form-item>-->
                    <!-- <el-form-item label="选择日期" >
                        <el-date-picker type="daterange" value-format="yyyy-MM-dd" v-model="dataTime"  transfer @change="getdatarange"start-placeholder="开始日期"
                          range-separator="至"  end-placeholder="结束日期" show-week-numbers placement="bottom-end" >
                      </el-date-picker>
                  </el-form-item> -->
                    <el-form-item label="日期">
                        <div class="block">
                            <!-- <span class="demonstration"></span> -->
                            <el-date-picker v-model="searchParams.endTime" type="month" format="yyyy-MM"
                                            placeholder="选择日期"></el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item style="margin-left: 20px">
                        <el-button type="primary" @click="getStatistics">查询</el-button>
                        <el-button type="primary" @click="DeviceExcel" style="margin-left: 10px">导出</el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </el-row>
        <el-row>
            <el-tabs type="border-card">
                <el-tab-pane label="计划保养信息">
                    <div class="tableBox">
                        <el-table stripe ref="multipleTable" :data="twoAnalyze" class="center"
                                  @selection-change="handleSelectionChange" @sort-change="sortChange">
                            <el-table-column prop="month" sortable label="月份"/>
<!--                            <el-table-column prop="totalLines" sortable label="总产线数"/>-->
                            <el-table-column prop="numLines" sortable label="保养产线数"/>
<!--                            <el-table-column prop="totalDevices" sortable label="总设备数"/>-->
                            <el-table-column prop="numDevices" sortable label="保养设备数"/>
                            <el-table-column prop="totalNumber" sortable label="总保养数"/>
                            <el-table-column prop="finishNumber" sortable label="保养完成数"/>
                        </el-table>
                    </div>
                    <!--<table id="mytable">
                        <thead>
                        <tr>
                            <th>月份</th>
                            <th>订单总数</th>
                            <th>订单完成数</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(order, key, index) in twoAnalyze">
                            <td>{{ key }}</td>
                            <td>{{ order.totalNumber }}</td>
                            <td>{{ order.finishNumber }}</td>
                        </tr>
                        </tbody>
                    </table>-->
                </el-tab-pane>
                <el-tab-pane label="图表">
                    <div id="main"></div>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </el-card>
</template>
<script>
    import { getPlanMaintainStatistics } from '../../../api/reportform.js'
    import moment from 'moment'

    const { export_json_to_excel } = require('../../vendor_excel/Export2Excel')
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')

    export default {
        name: 'PlanMaintainReport',
        data: function() {
            return {
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: ''
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    devCode: '',
                    sortSelected: '',
                    sort: '',
                    number: '',
                    startTime: '',
                    endTime: ''

                },
                isclear: false,
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                twoAnalyze: [],
                dataTime: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {

                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
            this.getdayValue()
        },
        methods: {
            getdayValue: function() {
                this.searchParams.endTime = new Date()
            },
            init: function() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                this.getFactory()
                this.getData()
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
            },
            fcChange: function() {
                this.mechanism.shopCode = ''
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            shopChange: function() {
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            sectionChange: function() {
                this.mechanism.lineCode = ''
                this.getStatistics()
            },
            lineChange: function() {
                this.getStatistics()
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                })
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.getStatistics()
                })
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            getStatistics: function() {
                var self = this
                self.searchParams.fcCode = ''
                self.searchParams.shopCode = ''
                self.searchParams.sectionCode = ''
                self.searchParams.lineCode = ''
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    self.searchParams.fcCode = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    self.searchParams.shopCode = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode != undefined && self.mechanism.sectionCode != '') {
                    self.searchParams.sectionCode = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    self.searchParams.lineCode = JSON.parse(self.mechanism.lineCode).deptCode
                }
                if (self.searchParams.endTime == undefined || self.searchParams.endTime == '') {
                    self.searchParams.endTime = moment(new Date()).format('YYYY-MM-DD')
                } else {
                    self.searchParams.endTime = moment(self.searchParams.endTime).format('YYYY-MM-DD')
                }

                getPlanMaintainStatistics(self.searchParams).then(function(resp) {
                    if (resp.status == 100) {
                        self.twoAnalyze = []
                        for (let i in resp.data) {
                            let array = {
                                month: '',
                                finishNumber: '',
                                totalNumber: '',
                                totalLines: '',
                                numLines: '',
                                totalDevices: '',
                                numDevices: ''
                            }
                            array.month = i
                            array.finishNumber = resp.data[i].finishNumber == undefined || resp.data[i].finishNumber == '' ? 0 : parseInt(resp.data[i].finishNumber)
                            array.totalNumber = resp.data[i].totalNumber == undefined || resp.data[i].totalNumber == '' ? 0 : parseInt(resp.data[i].totalNumber)
                            array.totalLines = resp.data[i].totalLines == undefined || resp.data[i].totalLines == '' ? 0 : parseInt(resp.data[i].totalLines)
                            array.numLines = resp.data[i].numLines == undefined || resp.data[i].numLines == '' ? 0 : parseInt(resp.data[i].numLines)
                            array.totalDevices = resp.data[i].totalDevices == undefined || resp.data[i].totalDevices == '' ? 0 : parseInt(resp.data[i].totalDevices)
                            array.numDevices = resp.data[i].numDevices == undefined || resp.data[i].numDevices == '' ? 0 : parseInt(resp.data[i].numDevices)
                            self.twoAnalyze.push(array)
                        }
                        var option = self.creatObject()
                        if (self.twoAnalyze == undefined || self.twoAnalyze == null) {
                            self.twoAnalyze = []
                            return
                        }
                        option.legend = {
                            show: true,
                            data: [/*'总产线数',*/ '保养产线数', /*'总设备数',*/ '保养设备数', '总保养数', '保养完成数'],
                            selected: {
                                /*'总产线数': true,*/
                                '保养产线数': true,
                                /*'总设备数': true,*/
                                '保养设备数': true,
                                '总保养数': true,
                                '保养完成数': true
                            }
                        }
                        option.series = [
                            /*{ name: '总产线数', type: 'bar', data: [] },*/
                            { name: '保养产线数', type: 'bar', data: [] },
                            /*{ name: '总设备数', type: 'bar', data: [] },*/
                            { name: '保养设备数', type: 'bar', data: [] },
                            { name: '总保养数', type: 'bar', data: [] },
                            { name: '保养完成数', type: 'bar', data: [] }
                        ]

                        for (var key in self.twoAnalyze) {
                            option.xAxis[0].data.push(self.twoAnalyze[key].month)
                            /*option.series[0].data.push(self.twoAnalyze[key].totalLines)*/
                            option.series[0].data.push(self.twoAnalyze[key].numLines)
                            /*option.series[2].data.push(self.twoAnalyze[key].totalDevices)*/
                            option.series[1].data.push(self.twoAnalyze[key].numDevices)
                            option.series[2].data.push(self.twoAnalyze[key].totalNumber)
                            option.series[3].data.push(self.twoAnalyze[key].finishNumber)
                        }
                        self.drawLine(option)
                    }
                })

            },
            drawLine(option) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption(option)
            },
            creatObject: function() {
                var option = {
                    title: { text: '计划性保养分析' },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: { show: true },
                            dataView: { show: true, readOnly: false },
                            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    grid: {
                        left: '10%',
                        bottom: '35%'
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: 40//-30度角倾斜显示
                        },
                        boundaryGap: ['20%', '20%']
                    }],
                    yAxis: [{
                        type: 'value',
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value}'
                        },
                        show: true
                    }]
                }
                return option
            },
            DeviceExcel: function() {
                var self = this
                self.excelData = []

                for (var key in self.twoAnalyze) {
                    var data = {
                        dateMonth: self.twoAnalyze[key].month,
                        totalLines: self.twoAnalyze[key].totalLines,
                        numLines: self.twoAnalyze[key].numLines,
                        totalDevices: self.twoAnalyze[key].totalDevices,
                        numDevices: self.twoAnalyze[key].numDevices,
                        totalNumber: self.twoAnalyze[key].totalNumber,
                        finishNumber: self.twoAnalyze[key].finishNumber
                    }
                    self.excelData.push(data)

                }
                self.DeviceExport()
            },
            formatJson: function(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            DeviceExport: function() {
                const tHeader = ['月份', '总产线数', '保养产线数', '总设备数', '保养设备数', '总保养数', '保养完成数']
                const filterVal = ['dateMonth', 'totalLines', 'numLines', 'totalDevices', 'numDevices', 'totalNumber', 'finishNumber']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), '计划性保养统计')
            }

        }
    }
</script>
<style lang="scss" scoped>
    #main {
        width: 1200px;
        height: 700px;
    }

    .box-card {
        // width: 70%;
    }

    #mytable {
        border: 1px solid #e4e5e6;
        padding: 0;
        margin: 0;
        border-collapse: collapse;
    }

    table {
        width: 100%;
    }

    th {
        width: 5vw;
        height: 3vw;
        border-bottom: 1px solid #e4e5e6;
        background-color: #eef3ff;
    }

    td {
        border-right: 1px solid #e4e5e6;
        border-bottom: none;
        font-size: 11px;
        padding: 6px 6px 6px 12px;
        color: #4f6b72;
    }

    td.alt {
        background: #f5fafa;
        color: #797268;
    }
</style>
